// Components
import { FormFull } from "form-full";
import { Grid } from "@material-ui/core";
import { Input, CustomText } from "../../../components/index";

// Hooks
import React from "react";
import { masks, hooks } from "../../../utils";
import { api } from "../../../services";
import { StorageContext } from "../../../contexts/StorageContext";
import alerts from "../../../utils/alerts";

// Styles
import Styles from "../styles";
import { fonts, Colors } from "../../../config";
import InputDados from "./InputDados";

// Interfaces
export interface OwnerDataProps {
    id: string;
    email: string;
    name: string;
    cpf: string;
    places: any[]
}

function DadosBasicos() {
    // hooks de requisição
    const [formRef, setFormRef] = React.useState<any>(null);
    const [owner, setOwner] = React.useState<any>(null);
    const { call, loading } = hooks.useRequest();
    const { userData } = React.useContext<any>(StorageContext);

    // Carregar dados completos do usuário logado ao montar o componente
    React.useEffect(() => {
        if (userData?.id) {
            call(null,
                api.getUserData(), (response) => {
                    if (response?.ok) {
                        setOwner(response.data);
                    }
                }
            )
        }
    }, [userData?.id]);

    const onSubmit = (data: any) => {
        const payload = {
            id: owner?.id,
            name: data.name,
            cpf: masks.removeNumberMask(data.cpf) || data.cpf,
            email: data.email,
            studiosIds: owner?.places ? owner.places.map((p: any) => p.id) : [],
        };

        call(
            null,
            api.putUserData(payload),
            (response) => {
                if (response?.ok) {
                    alerts.setErrorModal(
                        "Sucesso",
                        ["Alterações salvas com sucesso!"],
                        null,
                        "Ok",
                        "#0C396D"
                    );
                } else {
                    console.error("Erro ao salvar owner:", response);
                    alerts.alertError("Erro ao salvar alterações. Tente novamente.");
                }
            },
            (error) => {
                console.error("Erro na requisição:", error);
                alerts.alertError("Erro na requisição. Verifique sua conexão.");
            }
        );
    };
    return(
        <Styles.ContainerDadosBasicos>
            <CustomText
                fontSize={2} 
                textColor= {Colors.blue}
                fontFamily={fonts.bold}
            >
                Dados Básicos
            </CustomText>
            <Styles.FormContainer>
                {owner ? (
                <FormFull
                    key={owner?.id}
                    onSubmit={(data) => onSubmit(data)}
                    currentValues={owner}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={8} lg={6} >
                            <InputDados name="name" label="Nome Completo"  defaultValue={owner?.name || ""} placeholder="ex: Leandro Bittencourt" />
                        </Grid>
                        <Grid item xs={12} md={4} lg={3} >
                            <InputDados name="cpf" label="CPF" defaultValue={owner?.cpf || ""} mask={masks.CPF} maskToSubmit={masks.removeNumberMask} placeholder="ex: 123.456.789-00" />
                        </Grid>
                        <Grid item xs={12} md={4} lg={3} >
                            <InputDados name="email" label="E-mail" defaultValue={owner?.email || ""} placeholder="ex: email@exemplo.com" />
                        </Grid>
                    </Grid>
                    <Styles.SubmitContainer>
                        <Styles.Submit
                              loading={loading}
                              disabled={loading}
                            fullWidth={false}
                            action="submit"
                        >
                            Salvar Edições
                        </Styles.Submit>
                    </Styles.SubmitContainer>
                </FormFull>
                ) : (
                  <CustomText fontFamily={fonts.medium} fontSize={1} textColor={Colors.grayDim}>
                    Carregando dados...
                  </CustomText>
                )}
            </Styles.FormContainer>
        </Styles.ContainerDadosBasicos>
    )
}

export default DadosBasicos;